import React from "react";
import dot from "../../../assets/icons/threeDot.svg";
import styles from "./store-card.module.scss";

import { STORE_STATUS } from "../../../commons/constants/store";
interface props {
  status: STORE_STATUS;
  storeId?: string;
  handleOpenModal: () => void;
}
const StatusStore: React.FC<props> = ({ status, storeId, handleOpenModal }) => {
  function handleGetStoreStatus(status: STORE_STATUS) {
    switch (status) {
      case STORE_STATUS.LIVE:
        return "Active";
      case STORE_STATUS.SUSPENDED:
        return "Off";
      case STORE_STATUS.CLOSED:
        return "Closed";
      case STORE_STATUS.DRAFT:
        return "Draft";
      case STORE_STATUS.OFFLINE:
        return "Offline";
      default:
        return "Off";
    }
  }
  return (
    <div className={styles.statusBox}>
      <div className={`${styles.status} ${status === STORE_STATUS.LIVE ? styles.active : styles.suspend}`}>
        {handleGetStoreStatus(status)}
      </div>
      {storeId && (
        <div
          onClick={e => {
            e.stopPropagation();
            handleOpenModal();
          }}
          className={styles.dotIconWrapper}
        >
          <img src={dot} alt="dot" className={styles.dotIcon} />
        </div>
      )}
    </div>
  );
};

export default StatusStore;
